<template>
  <div>
    <div class="mx-auto max-w-prose lg:col-span-3 lg:mx-0">
      <div class="text-base font-bold text-yellow-400 uppercase">
        <span
          v-if="
            groupedProducts[selectedLocation].locationName !== 'All Locations'
          "
          >Prices & Availability In
          {{ groupedProducts[selectedLocation].locationTown }}</span
        >
        <span v-else>Prices & Availability</span>
      </div>
      <h2 class="text-3xl font-extrabold text-white">
        {{ groupedProducts[selectedLocation].locationName }}
      </h2>
      <UButton
        v-if="
          groupedProducts[selectedLocation].locationName !== 'All Locations'
        "
        variant="link"
        class="mt-1 -ml-2"
        :to="`/locations/${groupedProducts[selectedLocation].locationSlug}`"
        trailing-icon="i-lucide-arrow-right"
      >
        View Location
      </UButton>
    </div>
    <!-- Buttons for selecting a location -->
    <div
      v-if="groupedProducts.length > 1"
      class="gap-6 space-y-4 pt-4 pb-2 md:flex md:items-center md:justify-center md:space-y-0"
    >
      <div class="shrink-0 font-bold text-neutral-400 uppercase">
        Change Location:
      </div>
      <div
        :class="[
          'grid w-full grid-cols-1 gap-2 md:grid-cols-2',
          groupedProducts.length >= 3 ? 'md:grid-cols-3' : '',
        ]"
      >
        <UButton
          v-for="(group, index) in groupedProducts"
          :key="index"
          size="lg"
          variant="subtle"
          :class="[
            selectedLocation === index
              ? 'bg-yellow-400 text-black hover:bg-yellow-400/80'
              : '',
            'flex w-full cursor-pointer flex-col justify-center text-center',
          ]"
          @click="updateLocation(index)"
        >
          <span>{{ group.locationName }}</span>

          <span
            v-if="group.locationName !== 'All Locations'"
            class="-mt-2 font-semibold"
            >({{ group.locationTown }})</span
          >
        </UButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { GroupStoryblok } from '~/types/component-types-sb.d.ts';

interface Location {
  locationTown: string;
  locationName: string;
  locationSlug: string;
  locationUUID: string;
  products: Array<{
    name?: string;
    price?: string;
    duration?: string;
    age_range?: string;
    minimum_qty?: string;
    [key: string]: unknown;
  }>;
}

// Define props with TypeScript interfaces
defineProps<{
  blok: Pick<GroupStoryblok, 'disable_location_tabs'>;
  uuid: string;
  type: string;
  groupedProducts: Location[];
  selectedLocation: number;
}>();

// Define emits
const emit = defineEmits<{
  'update:selectedLocation': [index: number];
  'location-changed': [index: number];
}>();

// Method to handle location updates
const updateLocation = (index: number) => {
  emit('update:selectedLocation', index);
  emit('location-changed', index);
};
</script>
